import './CardsConfigView.scss';
// @vendor
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import Immutable from 'immutable';
// @components
import { infoGetRequested, logCardControlEnter } from 'actions/cardControl';
import { OKHeaderSubPage } from 'commonsComponents/OKHeaderSubPage';
import { OKCover } from 'commonsComponents/OKCover';
import CardDetailsSideBar from 'components/cards/cardDetailsSidebar/cardDetailsSidebar';
import CardHeaderDetails from 'components/cards/cardHeaderDetails/cardHeaderDetails';
import TabbedBox from 'components/commons/tabbedBox/tabbedBox';
import ContactInfoBox from 'components/myProfile/contactInfoBox/contactInfoBox';
import { getCard } from 'selectors/cards';
import CardsConfigChannels from './CardsConfigChannels';
import CardsConfigCountries from './CardsConfigCountries';
// @utilities
const { formatText, FormattedText } = require('core/i18n').i18n;

class CardsConfigView extends Component {
    componentDidMount() {
        const {
            card,
            getInfo,
            logCardControl,
            originCountry,
        } = this.props;
        if (!card.locations || !card.channels) {
            getInfo({
                cardId: card.cardId,
                pan: card.contract.number.padStart(card.contract.number.length, '0'),
                originCountry,
                lastDigitsPan : card.number.slice(-4),
            });
        } else {
            logCardControl();
        }
    }

    render() {
        const { card, flagBasedFeatures } = this.props;
        const subtitleLeft = formatText(`cards-${card.type}`);
        const subtitleRight = card.alias.current;
        return (
            <div className="cards__config">
                <div className="container-fluid">
                    <div className="row">
                        <OKCover
                            size="medium"
                            section="cards"
                            customClass="col-xs-12"
                        >
                            <OKHeaderSubPage
                                breadcrumbConfig={[
                                    { text: formatText('breadcrumb-cards'), url: '/myprofile/cards' },
                                    { text: card.alias.current, url: `/myprofile/cards/${card.cardId}/movements` },
                                    { text: formatText('cardsConfig-title') },
                                ]}
                                finalTitle={formatText('cardsConfig-title')}
                                subtitleLeft={subtitleLeft}
                                subtitleRight={subtitleRight}
                            >
                                <CardHeaderDetails immCard={Immutable.fromJS(card)} />
                            </OKHeaderSubPage>
                        </OKCover>
                    </div>
                </div>
                <div className="grid-view__body">
                    <div className="container-fluid">
                        <div className="row grid-view--content-position-negative">
                            <div className="col-xs-12 col-md-8 col-lg-8">
                                <div className="row">
                                    <div className="col-xs-12">
                                        <div className="tab--content">
                                            <TabbedBox
                                                left
                                                animated
                                                width={100}
                                                tabs={[
                                                    { label: formatText('cardsConfig-countriesTitle'), content: <CardsConfigCountries cardId={card.cardId} /> },
                                                    { label: formatText('cardsConfig-channelsTitle'), content: <CardsConfigChannels cardId={card.cardId} /> },
                                                ]}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xs-12 col-md-4 col-lg-4">
                                <div className="row">
                                    <div className="col-xs-12 col-sm-6 col-md-12 grid-view--variable-cell-separation">
                                        <CardDetailsSideBar
                                            immCard={Immutable.fromJS(card)}
                                            flagBasedFeatures={flagBasedFeatures} />
                                    </div>
                                    <div className="col-xs-12 col-sm-6 col-md-12 grid-view--fix-cell-separation">
                                        <ContactInfoBox
                                            boxTitle={formatText('cardsConfig-infoTitle')}
                                            boxBody={<FormattedText withCountrySuffix value="cardsConfig-infoContent" />}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}


CardsConfigView.propTypes = {
    card: PropTypes.object.isRequired,
    getInfo: PropTypes.func.isRequired,
    logCardControl: PropTypes.func.isRequired,
    originCountry: PropTypes.string.isRequired,
    flagBasedFeatures: PropTypes.object,
};

const mapStateToProps = (state, props) => ({
    card: getCard(state, props.match.params),
    originCountry: state.profile.get('originCountry'),
    flagBasedFeatures: state.flagBasedFeatures,
});

const mapDispatchToProps = dispatch => ({
    getInfo: ({ cardId, pan, originCountry, lastDigitsPan }) => dispatch(infoGetRequested({ cardId, pan, originCountry, lastDigitsPan })),
    logCardControl: () => dispatch(logCardControlEnter()),
});


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CardsConfigView));
